import { render } from "./RunHistogram.vue?vue&type=template&id=38d9555a&scoped=true"
import script from "./RunHistogram.vue?vue&type=script&lang=js"
export * from "./RunHistogram.vue?vue&type=script&lang=js"

import "./RunHistogram.vue?vue&type=style&index=0&id=38d9555a&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d9555a"]])

export default __exports__